"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackCreateApi = feedbackCreateApi;
exports.feedbackDeleteApi = feedbackDeleteApi;
exports.feedbackDetailApi = feedbackDetailApi;
exports.feedbackListApi = feedbackListApi;
exports.feedbackUpdateApi = feedbackUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

/**
 * 新增Feedback
 * @param pram
 */
function feedbackCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/feedback/save',
    method: 'POST',
    data: data
  });
}

/**
 * feedback更新
 * @param pram
 */
function feedbackUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/feedback/update',
    method: 'POST',
    data: data
  });
}

/**
 * feedback详情
 * @param pram
 */
function feedbackDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/feedback/info/".concat(id),
    method: 'GET'
  });
}

/**
 * feedback删除
 * @param pram
 */
function feedbackDeleteApi(data) {
  return (0, _request.default)({
    url: "/admin/feedback/delete",
    method: 'get',
    params: data // 接收对象参数
  });
}

/**
 * feedback列表
 * @param pram
 */
function feedbackListApi(params) {
  return (0, _request.default)({
    url: '/admin/feedback/list',
    method: 'GET',
    params: params
  });
}